'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SectionContent = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    max-width: ', 'px;\n    margin: 0 auto;\n    font-weight: 300;\n\n    & p {\n        margin-top: 0;\n        margin-bottom: 2em;\n        font-size: 1em;\n        line-height: 1.5em;\n    }\n'], ['\n    max-width: ', 'px;\n    margin: 0 auto;\n    font-weight: 300;\n\n    & p {\n        margin-top: 0;\n        margin-bottom: 2em;\n        font-size: 1em;\n        line-height: 1.5em;\n    }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SectionContent = exports.SectionContent = _styledComponents2.default.div(_templateObject, _styles.styles.MAX_CONTENT_WIDTH);
SectionContent.displayName = 'SectionContent';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/SectionContent.js
// module id = 53
// module chunks = 0